import { FieldValidator } from 'final-form';
import moment from 'moment';
import passwordValidator from 'password-validator';

//fix eslint regEx
//eslint-disable-next-line
export const mailRegEx = /^[\w!#$%&'\*\+\/\=\?\^`\{\|\}~\-]+(:?\.[\w!#\$%&'\*\+\/\=\?\^`\{\|\}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/i;
const schema = new passwordValidator();
schema.is().min(8).is().max(100).has().uppercase().has().lowercase().has().digits(1).has().symbols();

const validSnn = (value: string): string | undefined => {
  if (!value) return;
  if (value.length === 11) return;
  return 'Incorrect Social Security Number';
};

const validPhone = (value: string): string | undefined => {
  if (!value) return;
  if (value.replace(/-/g, '').length === 11) return;
  return 'Incorrect Phone Number';
};

const isPastDate = (value: string): boolean => {
  const now = moment().valueOf();
  const prev = moment(value, process.env.REACT_APP_DATE_FORMAT).valueOf();
  return now > prev;
};

const character = (value: string): string | undefined => {
  const hasSpecialChars = /[^a-z_]/i;
  if (value && (typeof value !== 'string' || (value.trim && value.trim())) && !(hasSpecialChars.test(value))) return;
  return 'Field is required and Special characters are not allowed';
};

const required = (value: string): string | undefined => {
  if (value && (typeof value !== 'string' || (value.trim && value.trim()))) return;
  return 'Field is required';
};

const validEmail = (value: string): string | undefined => {
  if (value && value.match(mailRegEx)) return;
  return 'Incorrect email address';
};

const validInitialsLimit = (value: string): string | undefined => {
  if (value && value.length <= 20) return;
  return 'Must be less than 20 characters';
};

const validPassword = (value: string) => {
  const errorsList = schema.validate(value, { list: true });

  if (typeof errorsList === 'boolean') return;

  const errorsMessages = errorsList.map((item: string) => {
    switch (item) {
      case 'min':
        return 'A minimum of 8 characters';
      case 'uppercase':
        return 'An uppercase character';
      case 'digits':
        return 'A numeric character';
      case 'lowercase':
        return 'A lowercase character';
      case 'symbols':
        return 'A special character';
      default:
        return '';
    }
  });

  return errorsMessages;
};

const pastDate = (value: string): string | undefined => {
  if (value && isPastDate(value)) return;
  return 'Invalid date';
};
const validName = (value: string): string | undefined => {
  const res = /^\s+$/.test(value);
  if (res) return 'The field cannot contain only spaces';
}
const cardNumber = (value: string): string | undefined => {
  value = value.replace(/\D/g, '').trim();
  if (value.length == 16 || value.length == 15) return;
  return 'Invalid card number';
};

const cardExpDate = (value: string): string | undefined => {
  if (value && value.includes('/')) {
    let month = parseInt(value.split('/')[0]);
    let year = parseInt(value.split('/')[1]);
    if (month && year) {
      let expDate = moment();
      expDate.set('date', 0);
      expDate.set('month', month-1);
      expDate.set('year', 2000 + year);
      if (expDate.valueOf() > moment().valueOf()) return;
    }
  }
  return 'Invalid date';
};
const cardCVC = (value: string): string | undefined => {
  if (value && (value.length == 3 || value.length == 4)) return;
  return 'Invalid CVV';
};

// eslint-disable-next-line
const compose = (...validators: ((...args: any[]) => string | undefined)[]): FieldValidator<any> => (...field) =>
  validators.reduce<string | undefined>((error, validator) => error || validator(...field), undefined);

export const Validators = {
  required,
  validEmail,
  pastDate,
  compose,
  validSnn,
  validPhone,
  validPassword,
  validName,
  cardNumber,
  cardExpDate,
  cardCVC,
  validInitialsLimit,
  character
};
